// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-report .tab-content {\n  border: 1px solid #CCC;\n  box-shadow: 0 0 10px 0 #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  background: white;\n}\n\n.is-invalid {\n  border: 1px solid red;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
